"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientSelect = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var prop_types_1 = (0, tslib_1.__importDefault)(require("prop-types"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var fos_ui_1 = require("@ntet/fos-ui");
var noop_1 = (0, tslib_1.__importDefault)(require("lodash/noop"));
var ClientSelect = function (_a) {
    var clients = _a.clients, selectClient = _a.selectClient;
    return (react_1.default.createElement(StyledPositionContainer, null,
        react_1.default.createElement(StyledText, null, "Please select your client"),
        react_1.default.createElement(StyledButtonList, null, clients.map(function (client) { return (react_1.default.createElement(StyledButton, { key: client, onClick: function () { return selectClient(client); } }, client)); }))));
};
exports.ClientSelect = ClientSelect;
ClientSelect.propTypes = {
    clients: prop_types_1.default.arrayOf(prop_types_1.default.string),
    selectClient: prop_types_1.default.func,
};
ClientSelect.defaultProps = {
    clients: [],
    selectClient: noop_1.default,
};
var StyledPositionContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 20rem;\n"], ["\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 20rem;\n"])));
var StyledButtonList = styled_components_1.default.div(templateObject_2 || (templateObject_2 = (0, tslib_1.__makeTemplateObject)(["\n  min-width: 30rem;\n  display: flex;\n  flex-direction: column;\n  padding-top: 2rem;\n"], ["\n  min-width: 30rem;\n  display: flex;\n  flex-direction: column;\n  padding-top: 2rem;\n"])));
var StyledButton = (0, styled_components_1.default)(fos_ui_1.Button)(templateObject_3 || (templateObject_3 = (0, tslib_1.__makeTemplateObject)(["\n  margin: 0.5rem 0 !important;\n  & .button_label_container {\n    justify-content: center;\n  }\n"], ["\n  margin: 0.5rem 0 !important;\n  & .button_label_container {\n    justify-content: center;\n  }\n"])));
var StyledText = styled_components_1.default.span(templateObject_4 || (templateObject_4 = (0, tslib_1.__makeTemplateObject)(["\n  font-family: ", ";\n  font-weight: 400;\n  font-size: 1.8rem;\n"], ["\n  font-family: ", ";\n  font-weight: 400;\n  font-size: 1.8rem;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.robotoMedium;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
